import React from "react";
import { FaComments } from "react-icons/fa"; // Importing chat icon from react-icons

const OpenChatButton = ({ onClick, messageCount }) => {
    return (
        <div className="video_button_container" style={{ position: "relative" }}>
            <FaComments
                className="video_button_icon chat"
                title="Talk Zone"
                size={40}
                color="blue"
                onClick={onClick}
            />
            {messageCount > 0 && (
                <span
                    className="message_count_badge"
                    style={{
                        position: "absolute",
                        top: "-5px",
                        right: "-5px",
                        backgroundColor: "red",
                        color: "white",
                        borderRadius: "50%",
                        padding: "2px 6px",
                        fontSize: "12px",
                        fontWeight: "bold",
                    }}
                >
                    {messageCount}
                </span>
            )}
        </div>
    );
};

export default OpenChatButton;
